import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { ButtonKind, ButtonSize, IButton } from './';

const kindClasses: Record<ButtonKind, string> = {
  primary: `bg-black text-white font-bold rounded-full duration-300
    hover:bg-50
    active:bg-50
    disabled:text-grey-40 disabled:border-0 disabled:bg-grey-20
    focus:outline focus:outline-6 focus:outline-grey-20`,
  primary_dark: `bg-white text-grey-80 font-bold rounded-full duration-300
    hover:bg-50 hover:text-white
    active:bg-50 active:text-white
    disabled:text-grey-40 disabled:border-0 disabled:bg-grey-20
    focus:outline focus:outline-6 focus:outline-grey-20`,
  secondary: `bg-transparent text-grey-80 border border-black font-bold rounded-full border-2 duration-300
    hover:border-50 hover:text-50
    active:border-50 active:text-50
    disabled:text-grey-40 disabled:border-grey-40
    focus:border-50 focus:text-50 focus:outline focus:outline-6 focus:outline-grey-20`,
  secondary_dark: `bg-transparent text-white border border-white font-bold rounded-full border-2 duration-300
    hover:border-50 hover:text-50
    active:border-50 active:text-50
    disabled:text-grey-40 disabled:border-grey-40
    focus:border-50 focus:text-50 focus:outline focus:outline-6 focus:outline-grey-20`,
  tertiary: `bg-transparent text-grey-80 font-bold rounded-full duration-300
    hover:text-50
    active:text-50
    disabled:text-grey-40 disabled:no-underline
    focus:text-50`,
  tertiary_dark: `bg-transparent text-white font-bold rounded-full duration-300
    hover:text-50
    active:text-50
    disabled:text-grey-40 disabled:no-underline
    focus:text-50`,
};

/*const sizeClasses: Record<ButtonSize, (kind: ButtonKind) => string> = {
  l: (kind) => (kind === 'tertiary' ? '' : 'py-4 px-6'),
  m: (kind) => (kind === 'tertiary' ? '' : 'py-3 px-6'),
  s: (kind) => (kind === 'tertiary' ? '' : 'py-1 px-4'),
};*/

const sizeClasses: Record<ButtonSize, (kind: ButtonKind) => string> = {
  xLarge: (kind) => (kind === 'tertiary' ? '' : 'py-3 px-6 lg:py-4 lg:px-6'),
  large: (kind) => (kind === 'tertiary' ? '' : 'py-3 px-6 lg:py-4 lg:px-6'),
  medium: (kind) => (kind === 'tertiary' ? '' : 'py-1 px-4 lg:py-3 lg:px-6'),
  small: (kind) => (kind === 'tertiary' ? '' : 'py-1 px-4 lg:py-3 lg:px-6'),
  gallery: (kind) => (kind === 'tertiary' ? '' : 'py-3 px-6 lg:py-4 lg:px-6'),
};

export function Button(props: IButton & HTMLAttributes<HTMLElement>) {
  const {
    className,
    children,
    iconRight,
    iconLeft,
    kind = 'primary',
    size = 'large',
    buttonType,
    action,
    submit = false,
    active = false,
    inContentBlock = false,
    ...rest
  } = props;

  const clickAction = () => {
    action();
  };

  return (
    <button
      type={submit ? 'submit' : 'button'}
      {...rest}
      onClick={action ? clickAction : null}
      className={cn(
        'group inline-flex justify-center items-center lg:whitespace-nowrap',
        //kindClasses[kind],
        sizeClasses[size](kind),
        className,
        typeof buttonType === 'undefined' ||
          buttonType === null ||
          buttonType === 'light'
          ? kindClasses[kind]
          : kindClasses[kind + '_dark'],
        active ? '!text-50' : '',
        inContentBlock ? 'w-auto' : '',
      )}
    >
      <div className="inline-flex flex-row gap-x-2">
        {iconLeft && (
          <span className={cn('flex items-center')}>{iconLeft}</span>
        )}
        <span className="button-label">{children}</span>
        {iconRight && (
          <span className={cn('flex items-center')}>{iconRight}</span>
        )}
      </div>
    </button>
  );
}
